const Views = self => ({
    get headquarters() {
        const { city, region } = self;
        return city && region ? `${city}, ${region}` : '';
    },
    get numberOfEmployees() {
        const { min, max } = self;
        if (!min || !max) {
            return '';
        }
        if (min > 100000 || max > 1000000) {
            return '+100,001';
        }
        return max > min
            ? `${min.toLocaleString()} - ${max.toLocaleString()} `
            : `${max.toLocaleString()} - ${min.toLocaleString()}`;
    },
    get social() {
        const { facebook, twitter, LinkedIn } = self;
        return { facebook, twitter, LinkedIn };
    },
    get revenue() {
        const { revenueRange } = self;
        return (revenueRange === null || revenueRange === void 0 ? void 0 : revenueRange.string) || '';
    },
    get hasTopics() {
        return self.topics.length > 0;
    },
});
export default Views;
